import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faUserCircle} from '@netx/core-icons';
import {UserActionLabel} from '../locales';

export const userActionProfileIcon = faUserCircle;

/**
 * Route to user profile
 * @param params
 * @returns Action
 */
export const userActionProfile = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-profile',
	cb: () => performAction('user:profile:route'),
	icon: userActionProfileIcon,
	get label() {
		return UserActionLabel.PROFILE;
	},
	routeMatch: /^user\/profile(\/?)/,
	...params,
});

export default userActionProfile;
